import { IBorderRadiusData, IFontData, IPxHeightData, IWidgetVisibility, SelfPosition, VisibilityData, WidgetFitMode, WidgetPlaceType } from "./index";
import { IAnimatedWidget } from "./widget-style-data";

export interface IButtonWidgetBaseData extends IWidgetVisibility {
    placeType: WidgetPlaceType;
    id?: string | null;
    style: IButtonWidgetBaseStyle | null;
    label: string;
    labelPlaceholder: string;
}

export interface IButtonWidgetBaseStyle extends IAnimatedWidget {
    heightData?: IPxHeightData | null;
    buttonStyle?: IButtonBaseStyle | null;
}

export interface IButtonBaseStyle {
    theme?: ButtonTheme | null;
    color?: string | null;
    hoverColor?: string | null;
    backgroundColor?: string | null;
    backgroundHoverColor?: string | null;
    borderColor?: string | null;
    borderHoverColor?: string | null;
    borderRadius?: IBorderRadiusData | null;
    font?: IFontData | null;
    thickness?: string | null;
    fitMode?: WidgetFitMode | null;
    buttonAlignment?: SelfPosition | null;
}

export type ButtonTheme = "primary" | "secondary";

export abstract class ButtonWidgetBaseData {

    public static get defaultData(): IButtonWidgetBaseData {
        return {
            placeType: "Section",
            label: "",
            labelPlaceholder: "BUTTON",
            style: this.defaultStyle,
            visibility: VisibilityData.defaultData()
        };
    }

    public static get defaultStyle(): IButtonWidgetBaseStyle {
        return {
            heightData: {
                height: 40,
            },
            buttonStyle: this.defaultButtonStyle,
            animation: {
                animationSource: "site-design",
                animationData: {
                    name: "none",
                    duration: 1
                }
            }
        };
    }

    public static get defaultButtonStyle(): IButtonBaseStyle {
        return {
            theme: "primary",
            borderRadius: {
                topLeftPx: 0,
                topRightPx: 0,
                bottomLeftPx: 0,
                bottomRightPx: 0
            },
            font: {
                weight: "",
                family: "",
                size: "",
                lineHeight: "1.5em"
            },
            thickness: "0px",
            fitMode: "cover",
            buttonAlignment: "center"
        };
    }

}
